import { GetStaticProps } from "next"
import { Container, Box, Grid, Paper, Hidden } from "@mui/material"

import { makeStyles } from "makeStyles"

import SEO from "components/SEO"
import { Phone, Email } from "components/i18n/Contact"
import WebsiteInfoNav from "containers/HelpCenter/WebSiteInfoNav"

import { openingHours, openingHoursPL } from "@secureo/common/config/contact"
import { getServerTranslations } from "utils/i18n/getServerTranslations"

const useStyles = makeStyles()((theme) => ({
	paper: {
		padding: theme.spacing(3),
		paddingRight: theme.spacing(1),
		color: "#274041",
		boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
		marginBottom: "20px",
	},
}))

const ImprintDE = () => {
	return (
		<>
			<h1 className="h3" style={{ textTransform: "uppercase" }}>
				Impressum
			</h1>
			<p>Gesetzliche Anbieterkennung:</p>
			<p>
				<strong>SECUREO GmbH</strong>
				<br />
				vertreten durch die Geschäftsführerin Caroline Reinalter
				<br />
				<br />
				<strong>Im Moos 19</strong>
				<br />
				<strong>6067 Absam</strong>
				<br />
				<strong>Österreich</strong>
				<br />
				<br />
				<strong>Telefon:</strong>{" "}
				<span style={{ color: "#168db5" }}>
					<Phone />
				</span>
				<br />
				{openingHours}
				<br />
				<br />
				<strong>E-Mail:</strong>{" "}
				<span style={{ color: "#168db5" }}>
					<Email />
				</span>
				<br />
				<br />
				USt-IdNr. Österreich: ATU68967825 | USt-IdNr. Deutschland: DE297458371
				<br />
				Firmenbuch-Gericht: Landesgericht Insbruck
				<br />
				Firmenbuchnummer: 422359t
				<br />
			</p>
			<p>
				Mitgliedschaften: WKO, Händlerbund Gesetzliche Vorschriften: Unternehmensgesetzbuch
				/ GmbH-Gesetz: www.ris.bka.gv.at Aufsichtsbehörde: Landesgericht Innsbruck Die
				europäische Online-Streitbeilegungsplattform („OS-Plattform“) wird nach
				Bereitstellung durch die EU-Kommission über das Portal „Ihr Europa“
				europa.eu/youreurope/citizens zugänglich sein.
			</p>
			<p>
				Wir sind Mitglied der Initiative &quot;FairCommerce&quot;.
				<br />
				Nähere Informationen hierzu finden Sie unter www.fair-commerce.de.
			</p>
			<p className="bold">Rechtliche Hinweise zur Webseite</p>
			<p>
				Alle Texte, Bilder und weiter hier veröffentlichten Informationen unterliegen dem
				Urheberrecht des Anbieters, soweit nicht Urheberrechte Dritter bestehen. In jedem
				Fall ist eine Vervielfältigung, Verbreitung oder öffentliche Wiedergabe
				ausschließlich im Falle einer widerruflichen und nicht übertragbaren Zustimmung des
				Anbieters gestattet.
			</p>
			<p>
				Für alle mittels Querverweis (Link) verbundenen Webinhalte übernimmt der Anbieter
				keine Verantwortung, da es sich hierbei nicht um eigene Inhalte handelt. Die
				verlinkten Seiten wurden auf rechtswidrige Inhalte überprüft, zum Zeitpunkt der
				Verlinkung waren solche nicht erkennbar. Verantwortlich für den Inhalt der
				verlinkten Seiten ist deren Betreiber. Der Anbieter hat hierzu keine allgemeine
				Überwachungs- und Prüfungspflicht. Bei Bekanntwerden einer Rechtsverletzung wird der
				entsprechende Link jedoch umgehend entfernt.
			</p>
			<p className="bold">
				Alternative Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO und § 36 VSBG:
			</p>
			<p>
				Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
				bereit, die Sie unter{" "}
				<a
					href="https://ec.europa.eu/consumers/odr/"
					target="_blank"
					rel="noopener noreferrer"
				>
					ec.europa.eu/customers/odr
				</a>
				. Gemäß der Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten.
				Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
				Verbraucherschlichtungsstelle sind wir verpflichtet und bereit.
			</p>
		</>
	)
}

const ImprintPL = () => {
	return (
		<>
			<h1 className="h3" style={{ textTransform: "uppercase" }}>
				Impressum
			</h1>
			<p>Prawna identyfikacja dostawcy:</p>
			<p>
				<strong>SECUREO GmbH</strong>
				<br />
				reprezentowana przez dyrektora zarządzającego Caroline Reinalter
				<br />
				<br />
				<strong>Im Moos 19</strong>
				<br />
				<strong>6067 Absam</strong>
				<br />
				<strong>Austria</strong>
				<br />
				<br />
				<strong>Phone:</strong>{" "}
				<span style={{ color: "#168db5" }}>
					<Phone />
				</span>
				<br />
				{openingHoursPL}
				<br />
				<br />
				<strong>E-Mail:</strong>{" "}
				<span style={{ color: "#168db5" }}>
					<Email />
				</span>
				<br />
				<br />
				NIP Austria: ATU68967825 | NIP Niemcy: DE297458371
				<br />
				Sąd rejestrowy spółki: Sąd Rejonowy w Insbruku
				<br />
				Numer z rejestru handlowego spółek: 422359t
				<br />
			</p>
			<p>
				Członkostwa: WKO, Händlerbund Gesetzliche Vorschriften: Unternehmensgesetzbuch /
				GmbH-Gesetz: www.ris.bka.gv.at Organ nadzorczy: Landesgericht Innsbruck Europejska
				platforma rozwiązywania sporów online („platforma OS“) będzie dostępna za
				pośrednictwem portalu „Twoja Europa“ europa.eu/youreurope/citizens po jej
				udostępnieniu przez Komisję UE.
			</p>
			<p>
				Jesteśmy członkiem inicjatywy &quot;FairCommerce&quot;.
				<br />
				Więcej informacji na ten temat można znaleźć na stronie www.fair-commerce.de.
			</p>
			<p className="bold">Informacje prawne dotyczące strony internetowej</p>
			<p>
				Wszystkie opublikowane tu teksty, zdjęcia i inne informacje podlegają prawu
				autorskiemu oferenta, o ile nie istnieją prawa autorskie osób trzecich. W każdym
				przypadku kopiowanie, rozpowszechnianie lub publiczne odtwarzanie jest dozwolone
				wyłącznie za odwołalną i nieprzenoszalną zgodą oferenta. Oferent nie ponosi
				odpowiedzialności za treści internetowe, do których prowadzą linki z tej strony,
				ponieważ nie są to treści własne oferenta. Połączone strony zostały sprawdzone pod
				kątem nielegalnych treści; w momencie umieszczania linków nie można było
				zidentyfikować takich treści. Za treść stron, do których prowadzą linki, odpowiada
				ich operator. Świadczeniodawca nie ma ogólnego obowiązku monitorowania ani
				sprawdzania tego. Jednakże, jeśli naruszenie zostanie ujawnione, odpowiedni link
				zostanie natychmiast usunięty.
			</p>
			<p className="bold">
				Alternatywne rozwiązywanie sporów zgodnie z art. 14 (1) Rozporządzenia ODR i § 36
				VSBG:
			</p>
			<p>
				Komisja Europejska udostępnia platformę do rozwiązywania sporów online (OS), do
				której można uzyskać dostęp pod adresem{" "}
				<a
					href="https://ec.europa.eu/consumers/odr/"
					target="_blank"
					rel="noopener noreferrer"
				>
					ec.europa.eu/customers/odr
				</a>
				. Zgodnie z rozporządzeniem w sprawie internetowego systemu rozstrzygania sporów
				konsumenckich. Jesteśmy zobowiązani i gotowi do udziału w postępowaniu w sprawie
				rozwiązywania sporów przed polubownym sądem konsumenckim.
			</p>
		</>
	)
}

const ImprintPage = ({ language }: Props) => {
	const { classes } = useStyles()

	return (
		<>
			<SEO pageType="imprint" asPath={"/imprint"} />
			<Box mt={5}>
				<Container>
					<Grid container spacing={3}>
						<Hidden mdDown>
							<Grid item xs={12} md={3}>
								<WebsiteInfoNav />
							</Grid>
						</Hidden>
						<Grid item xs={12} md={9}>
							<Paper className={classes.paper}>
								{language === "de" && <ImprintDE />}
								{language === "pl" && <ImprintPL />}
							</Paper>
						</Grid>
						<Hidden mdUp>
							<Grid item xs={12} md={3}>
								<WebsiteInfoNav />
							</Grid>
						</Hidden>
					</Grid>
				</Container>
			</Box>
		</>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		language: context.locale.split("-")?.[0] ?? "de",
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"legal",
		])),
	}

	return {
		props,
	}
}

interface Props {
	language: string
}

export default ImprintPage
